module.exports = __webpack_public_path__ + "94fc01c9a46a969785dbf1cddb77b957.svg";